<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.9025 14.073L15.0001 1.09766L1.09766 14.073"
      stroke="#040A34"
      stroke-width="2.19512"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.0458 12.3477V27.0468C27.0458 28.0707 26.216 28.9005 25.1921 28.9005H4.8019C3.77806 28.9005 2.94824 28.0707 2.94824 27.0468V12.3477"
      stroke="#040A34"
      stroke-width="2.19512"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.375 12.75V28.5H2.625V12.75L15 1.125L27.375 12.75ZM10 18C9.44772 18 9 18.4477 9 19C9.00013 19.5522 9.4478 20 10 20H20L20.1025 19.9951C20.6065 19.9437 20.9999 19.5175 21 19C21 18.4824 20.6065 18.0563 20.1025 18.0049L20 18H10Z"
      fill="#040A34"
    />
  </svg>
</template>
